import {
  Grid,
  TextField,
  Table,
  TableCell,
  TableBody,
  TableRow
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import _ from 'lodash';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PageHeader from '../common/PageHeader';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import {
  EnhancedTableHead,
  GenerateAbsoluteURL,
  getCurrentPayCycleEndDateByDate,
  getCurrentPayCycleStartDateByDate,
  removeDuplicates,
  orderBy, orderByMultiple,
  getPreviousPayCycle,
  disableDatesForPayCycleStart1,
  disableDatesForPayCycleEnd1,
  getNumberOfPayCycle,
  getMaxDate,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import { getMultilevelGroupedData } from '../../utils/generic';
import { getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

// Header columns array 
const headCells = [
  {
    id: 'effectiveFrom',
    numeric: false,
    disablePadding: true,
    label: 'Allocation Start Date',
    type: 'Text'
  },
  {
    id: 'effectiveThrough',
    numeric: false,
    disablePadding: true,
    label: 'Allocation End Date',
    type: 'Text'
  },
  {
    id: 'rate',
    numeric: true,
    disablePadding: true,
    label: 'Allocation %',
    type: 'Number',
    isSort: false
  },
  {
    id: 'totalAllocationPercent',
    numeric: true,
    disablePadding: true,
    label: 'Total Approved Employee Allocation %',
    type: 'Number',
    isSort: false
  }

];
let temcurrentGroupedRow = [];
export default class MarketAllocationSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      employeeData: [],      
      startDate: getPreviousPayCycle().previousPayCycleStartDate,
      endDate: getPreviousPayCycle().previousPayCycleEndDate,
      futureEndDate: getCurrentPayCycleEndDateByDate(moment().format(DateFormat)),
      showReport: false,
      marketMasterData: [],
      departmentMasterData: [],
      designationMasterData: [],
      propertyMasterData: [],
      employeeMasterData: [],
      divisionMasterData: [],
      //   employeeSupervisorList: [],
      market: [{ marketName: 'All' }],
      designation: [{ designation: 'All' }],
      department: [{ departmentName: 'All' }],
      //   supervisor: [{ supervisorName: 'All' }],
      property: [{ propertyName: 'All' }],
      employee: [{ employeeName: 'All' }],
      SupervisorEmployee: [{ employeeName: 'All' }],
      supervisorEmployeeMasterData: [],
      division: [{ division: 'All' }],
      openSlidingPanel: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Market',
              value: 'allocatedMarket',
              id: 'allocatedMarket',
              ssrsReport: 'Market',
              numeric: false,
              disablePadding: false,
              label: 'Market',
              type: 'Text',
              order: 1
            },
            {
              key: 'Department',
              value: 'homeDepartment',
              ssrsReport: 'HomeDepartment',
              numeric: false,
              disablePadding: false,
              label: 'Department',
              type: 'Text',
              id: 'homeDepartment',
              order: 2
            },
            {
              key: 'Division',
              id: 'division',
              value: 'division',
              ssrsReport: 'Division',
              numeric: false,
              disablePadding: false,
              label: 'Division',
              type: 'Text',
              order: 3
            },
            {
              key: 'Employee Name',
              value: 'employeeName',
              id: 'employeeName',
              ssrsReport: 'EmployeeName',
              numeric: false,
              disablePadding: false,
              label: 'Employee Name',
              type: 'Text',
              order: 4
            }
          ],
          selected: []
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: false,
        summaryRows: false,
        showZeroNGraph: false,
        startDate: getPreviousPayCycle().previousPayCycleStartDate,
        endDate: getPreviousPayCycle().previousPayCycleEndDate,
        order: 'asc',
        orderBy: 'nam'
      }
    };

    this.baseState = this.state;
  }

  // This method is used to get master data before components mounted
  componentDidMount() {
    this.GetMasterData();
  }

  // Get Master data required to fill filters
  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData'
      },
      {
        url: API_URL.Employee.GetDesignationMasterData,
        key: 'designationMasterData'
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Allocation.GetDivisions,
        key: 'divisionMasterData'
      }
      // {
      //   url: API_URL.Employee.GetEmployeeSupervisorList,
      //   key: 'employeeSupervisorList'
      // }
    ])
      .then(
        ({
          marketMasterData,
          departmentMasterData,
          designationMasterData,
          employeeMasterData,
          propertyMasterData,
          divisionMasterData
        }) => {
          this._asyncRequest = null;
          if (marketMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }

          this.setState({
            marketMasterData: marketMasterData.data,
            departmentMasterData: departmentMasterData.data,
            designationMasterData: designationMasterData.data,
            employeeMasterData: employeeMasterData.data,
            propertyMasterData: propertyMasterData.data,
            divisionMasterData: divisionMasterData.data,
            supervisorEmployeeMasterData: employeeMasterData.data || []

          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
              this.GetTerminatedEmployee();
            }            
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Go to Reports list
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Date change event of calendar
  handleDateChange = (date, name) => {
    const { advanceFilterConfig, endDate } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');
    let formattedDate = moment(date).format(DateFormat);
    const count = getNumberOfPayCycle(formattedDate, endDate);
    let futureEndDate = getMaxDate(formattedDate);
    
    if (name === 'startDate') {
      formattedDate = getCurrentPayCycleStartDateByDate(formattedDate).format(DateFormat);
      advanceFilterConfig.startDate = formattedDate; // moment(date).format(DateFormat);      
      localStorage.setItem('selectedstartDate', formattedDate);
      futureEndDate = moment(getCurrentPayCycleEndDateByDate(moment(formattedDate).format('MM/DD/YYYY'))).format('MM/DD/YYYY');
      this.setState({        
        [name]: formattedDate, // moment(date).format(DateFormat)
        futureEndDate,
        endDate: futureEndDate
      });
    } else {
      formattedDate = getCurrentPayCycleEndDateByDate(date).format(DateFormat);
      advanceFilterConfig.endDate = formattedDate; // moment(date).format(DateFormat);      
      localStorage.setItem('selectedendDate', formattedDate);
      this.setState({        
        [name]: formattedDate // moment(date).format(DateFormat)
      });
    }
  };

  // Disable other dates  except pay cycle start dates (i.e. Excluding 1 & 16) on Pay Cycle Start calendar
  disableDatesForPayCycleStart = (date) => {
    return disableDatesForPayCycleStart1(date);
  }

  // Disable other date except pay cycle end dates (i.e. excluding mid and last day of the month) on Pay Cycle End calendar
  disableDatesForPayCycleEnd = (date) => {
    return disableDatesForPayCycleEnd1(date);
  }

  // Get Report Data based on selected filters
  GetTerminatedEmployee = () => {
    const {
      startDate,
      endDate,
      market,
      department,
      designation,
      property,
      employee,
      division,
      SupervisorEmployee
    } =
      this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const designationId = _.cloneDeep(designation.map((x) => x.designationID));
    //   const supervisorId = _.cloneDeep(supervisor.map((x) => x.supervisorId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const divisionId = _.cloneDeep(division.map(x => x.divisionId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));
    const params = {
      startDate: moment(startDate).format(DateFormat),
      endDate: moment(endDate).format(DateFormat),
      marketId: marketId.join('|'),
      departmentId: departmentId.join('|'),
      designationId: designationId.join('|'),
      propertyId: propertyId.join('|'),
      employeeId: employeeId.join('|'),
      divisionId: divisionId.join('|'),
      supervisorId: supervisorId.join('|')
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetMarketAllocationSummary,
        params,
        key: 'marketAllocationSummary'
      }
    ])
      .then(({ marketAllocationSummary }) => {
        this._asyncRequest = null;
        if (marketAllocationSummary.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        const UIData = this.renderTableRow(marketAllocationSummary.data || []);
        this.setState({
          employeeData: marketAllocationSummary.data,
          employeeSummary: marketAllocationSummary.config,
          showReport: true,
          isSubmitButtonClicked: true,
          UIData: UIData
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Reset filters and load the report data
  resetPage = () => {    
    const { advanceFilterConfig } = this.state;    
    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Market',
          value: 'allocatedMarket',
          id: 'allocatedMarket',
          ssrsReport: 'Market',
          numeric: false,
          disablePadding: false,
          label: 'Market',
          type: 'Text',
          order: 1
        },
        {
          key: 'Department',
          value: 'homeDepartment',
          ssrsReport: 'HomeDepartment',
          numeric: false,
          disablePadding: false,
          label: 'Department',
          type: 'Text',
          id: 'homeDepartment',
          order: 2
        },
        {
          key: 'Division',
          id: 'division',
          value: 'division',
          ssrsReport: 'Division',
          numeric: false,
          disablePadding: false,
          label: 'Division',
          type: 'Text',
          order: 3
        },
        {
          key: 'Employee Name',
          value: 'employeeName',
          id: 'employeeName',
          ssrsReport: 'EmployeeName',
          numeric: false,
          disablePadding: false,
          label: 'Employee Name',
          type: 'Text',
          order: 4
        }
      ],
      selected: []
    };
    this.setState({
      ...this.baseState,
      isSubmitButtonClicked: false,
      advanceFilterConfig
    }, () => this.GetMasterData());    
  };

  // Handle event of Run Report button click
  handleSubmit = () => {
    localStorage.setItem('DateRadioSelect', 'CDR');
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);    
    this.GetTerminatedEmployee();
  };

  // Handle change event of filtered values
  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  // Open sliding panel
  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.startDate);
    localStorage.setItem('selectedendDate', this.state.endDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  // Handle event to change advanced filter/grouped values and get report on selected filters
  onAddvanceFilterChange = (advanceFilterConfig) => {    
    this.setState(
      {
        advanceFilterConfig: advanceFilterConfig,
        openSlidingPanel: false        
      },
      () => this.GetTerminatedEmployee()
    );
  };

  // Get column sequence based on grouping selected on Advanced filter
  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.groupBy.selected.length === 0) {
      return removeDuplicates(
        [          
          ...this.state.advanceFilterConfig.groupBy.masterData
        ],
        'key'
      );
    } else {
      return removeDuplicates(
        [
          ...this.state.advanceFilterConfig.groupBy.selected,
          ...this.state.advanceFilterConfig.groupBy.masterData
        ],
        'key'
      );
    }
  };

  // Adjust column sequences
  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach((x) => {
      currentGroupedRow.push({ key: x.value });
    });
    return currentGroupedRow;
  };

  // Get grouped data based on selected grouping on Advanced filters
  getMultilevelGroupedSortedData = (data) => {
    data = orderBy(data, this.state.orderBy, this.state.order);
    const selectedGroupLength = this.state.advanceFilterConfig.groupBy.selected.length;
    if (selectedGroupLength > 0) {      
      return orderByMultiple(data, this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value),
        this.state.advanceFilterConfig.groupBy.selected.map((x) => this.state.order),
        true);
    } else {
      return orderBy(data, this.state.orderBy, this.state.order);
    }
  };

  // Render record wise row 
  renderTableRow = (data) => {
    if (this.state.advanceFilterConfig.suppressZero === true) {
      data = data.filter((x) => {
        return (
          _.chain(x.reimbursmentDetails)
            .sumBy((x) => x.reimbursementCost)
            .value() !== 0
        );
      });
    }
    const selectedGroupLength = this.state.advanceFilterConfig.groupBy.selected.length;
    if (selectedGroupLength > 0) {
      temcurrentGroupedRow = [];
      return this.renderTableCell(
        getMultilevelGroupedData(
          data,
          this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)
        ),
        []
      );
    } else {
      temcurrentGroupedRow = [];
      return this.renderTableCell(
        getMultilevelGroupedData(
          data,
          []
        ),
        []
      );
    }
  };

  // Render table cell into table with formatted values
  renderTableCell = (
    groupedData,
    currentGroupedRow = [],
    tableCell = [],
    rowCount = 0
  ) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const sequence = this.getColumnSequence();
    
    groupedData.forEach((d, i) => {
      let column1 = (temcurrentGroupedRow.find(x => x.key === sequence[0].value) || {})?.value || null;
      let column2 = (temcurrentGroupedRow.find(x => x.key === sequence[1].value) || {})?.value || null;
      let column3 = (temcurrentGroupedRow.find(x => x.key === sequence[2].value) || {})?.value || null;
      let column4 = (temcurrentGroupedRow.find(x => x.key === sequence[3].value) || {})?.value || null;

      if (d.data !== undefined) {        
        this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      } else {
        const groupColumns = this.state.advanceFilterConfig.groupBy.selected;

        groupColumns?.forEach(g => {
          temcurrentGroupedRow = temcurrentGroupedRow.filter((x) => x.key !== g.value);

          temcurrentGroupedRow.push({ key: g.value, value: d[g.value] });
        });
      }
      const keyvalue = this.adjustColumnSequence(
        _.cloneDeep(temcurrentGroupedRow)
      );
      
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const topBorderClass =
        column1 !==
          (keyvalue.find((x) => x.key === sequence[0].value) || {}).value ?? ''
          ? ' rpt-topBorder '
          : ' ';

      const key =
        d.market +
        d.department +
        d.employeeId +
        '_' +
        rowCount +
        '_' +
        i;
      if (d.data === undefined) {
        tableCell.push(
          <TableRow className={topBorderClass}>
            <TableCell className={evenOddClass + topBorderClass + ' st sticky'}>
              {getFormattedValues(
                column1 !== d[sequence[0].value] && d[sequence[0].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-1 ' +
                evenOddClass +
                ((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[1].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-2 ' +
                evenOddClass +
                ((column3 !== d[sequence[2].value] || (column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column3 !== d[sequence[2].value] || (column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])) && d[sequence[2].value],
                'Text'
              )}{' '}
            </TableCell>
            <TableCell
              className={
                'st sticky-3 ' +
                evenOddClass +
                ((column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) ? ' rpt-topBorder ' : ' ')
              }
            >
              {getFormattedValues(
                (column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[3].value],
                'Text'
              )}{' '}
            </TableCell>

            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.effectiveFrom === null
                ? 'NA'
                : getFormattedValues(d.effectiveFrom, 'Date')}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.termination_Date === null
                ? 'NA'
                : getFormattedValues(d.effectiveThrough, 'Date')}
            </TableCell>

            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.rate === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.rate, 'DecimalPercent')}</span>}
            </TableCell>

            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {d.totalAllocationPercent === null
                ? 'NA'
                : <span className='fixed-amount'>{getFormattedValues(d.totalAllocationPercent, 'DecimalPercent')}</span>}
            </TableCell>

          </TableRow>
        );
      }
      rowCount++;
      column1 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[0].value) || {}).value ?? null;
      column2 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[1].value) || {}).value ?? null;
      column3 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[2].value) || {}).value ?? null;
      column4 =
        (temcurrentGroupedRow.find((x) => x.key === sequence[3].value) || {}).value ?? null;
    });
    return tableCell;
  };

  // Close sliding panel
  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  // Download report in excel or pdf format
  downloadFile = (fileMimeType, type, isPrint) => {
    let { market, department, property, employee, endDate, startDate, advanceFilterConfig, designation, SupervisorEmployee, division } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(startDate).format(DateFormat) },
      { key: 'EndDate', value: moment(endDate).format(DateFormat) }
    ];

    market = market.filter(x => x.marketName !== 'All');
    department = department.filter(x => x.departmentName !== 'All');
    property = property.filter(x => x.propertyName !== 'All');
    employee = employee.filter(x => x.employeeName !== 'All');
    division = division.filter(x => x.division !== 'All');

    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const divisionId = _.cloneDeep(division.map((x) => x.divisionId));
    if (market && market.length > 0) {
      dataValue.push({ key: 'MarketId', value: marketId.join('|') === undefined ? '' : marketId.join('|') });
    }

    if (property && property.length > 0) {
      dataValue.push({ key: 'PropertyId', value: propertyId.join('|') === undefined ? '' : propertyId.join('|') });
    }

    if (division && division.length > 0) {
      dataValue.push({ key: 'DivisionId', value: divisionId.join('|') === undefined ? '' : divisionId.join('|') });
    }

    if (department && department.length > 0) {
      dataValue.push({ key: 'DepartmentId', value: departmentId.join('|') === undefined ? '' : departmentId.join('|') });
    }
    if (employee && employee.length > 0) {
      dataValue.push({ key: 'EmployeeId', value: employeeId.join('|') === undefined ? '' : employeeId.join('|') });
    }

    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    if (supervisorId && supervisorId.length > 0) {
      dataValue.push({ key: 'supervisorId', value: supervisorId.join('|') === undefined ? '' : supervisorId.join('|') });
    }

    const url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Market%20Allocation%20Summary%20Report', type);
    downloadReport(
      url,
      'Market Allocation Summary',
      fileMimeType,
      type,
      isPrint
    );
  }

  // Handle table column sorting
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    }, () => { this.forceUpdate(); });
  };

  // Render table with report data
  renderTable = (employeeData) => {
    const groupSequence = this.getColumnSequence();
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={employeeData.length}
          columnSequence={groupSequence}
          headCells={headCells}
        />
        {/* <TableHead>
            <TableRow>
              {groupSequence.map((col, index) => (
                <TableCell key={'th' + col.value + index}>{getFormattedHeaders(col.key, 'Text')}</TableCell>
              ))}
              <TableCell>{getFormattedHeaders('Email', 'Text')}</TableCell>
              <TableCell>{getFormattedHeaders('Hire Date', 'Text')}</TableCell>
              <TableCell>{getFormattedHeaders('Termination Date', 'Text')}</TableCell>
            </TableRow>
          </TableHead> */}
        <TableBody>
          {employeeData.length > 0            
            ? this.renderTableRow(employeeData)
            : <label className="item-small">No Data Available.</label>
          }</TableBody>
      </Table>
    );
  };

  Row = ({ index, key, style }) => (
    this.state.UIData[index]
  );

  // Render method to render components
  render() {
    const {
      showMain,
      employeeData,
      startDate,
      endDate,
      marketMasterData,
      departmentMasterData,
      designationMasterData,
      employeeMasterData,
      // employeeSupervisorList,
      propertyMasterData,
      showReport,
      advanceFilterConfig,
      openSlidingPanel,
      futureEndDate,
      divisionMasterData,
      supervisorEmployeeMasterData
    } = this.state;
    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (designationMasterData.find(x => x.designation === 'All') === undefined) {
      designationMasterData.unshift({ designation: 'All' });
    }
    if (departmentMasterData.find(x => x.departmentName === 'All') === undefined) {
      departmentMasterData.unshift({ departmentName: 'All' });
    }

    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }

    if (propertyMasterData.find(x => x.propertyName === 'All') === undefined) {
      propertyMasterData.unshift({ propertyName: 'All' });
    }
    if (divisionMasterData.find(x => x.division === 'All') === undefined) {
      divisionMasterData.unshift({ division: 'All' });
    }

    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }

    return (
      <>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'Market_Allocation_Summary_Report'}
                title={'Market Allocation Summary Report '}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Market Allocation Summary
              </PageHeader>
              <Grid container spacing={3} className="no-print row bottom-xs">
                <Grid item xs={12} md={3} lg={3} style={{ marginLeft: '1.3rem' }}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    value={this.state.market}
                    onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                    id="tags-standard"
                    options={marketMasterData}
                    limitTags={2}
                    getOptionLabel={(option) => option.marketName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Market"
                      // placeholder="Market"
                      />
                    )}
                  />
                  <Autocomplete
                    blurOnSelect
                    multiple
                    limitTags={1}
                    id="tags-standard"
                    value={this.state.division}
                    options={removeDuplicates(divisionMasterData, 'division')}
                    onChange={(e, val) => this.handleChange(e, val, 'division', 'division')}
                    getOptionLabel={(option) => option.division}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Division"
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    limitTags={1}
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.SupervisorEmployee || ''}
                    options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                    getOptionLabel={(option) => option.employeeName}
                    onChange={(e, val) => {
                      this.handleChange(e, val, 'SupervisorEmployee', 'employeeName');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Supervisor Name"
                      // placeholder="Employee Name"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <Autocomplete
                    multiple
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.department}
                    onChange={(e, val) => this.handleChange(e, val, 'department', 'departmentName')}
                    options={departmentMasterData}
                    limitTags={2}
                    getOptionLabel={(option) => option.departmentName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Department"
                      // placeholder="Department"
                      />
                    )}
                  />
                  <Autocomplete
                    multiple
                    blurOnSelect
                    id="tags-standard"
                    value={this.state.employee}
                    onChange={(e, val) =>
                      this.handleChange(e, val, 'employee', 'employeeName')
                    }
                    options={employeeMasterData}
                    limitTags={2}
                    getOptionLabel={(option) => option.employeeName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Employee Name"
                      // placeholder="Title"
                      />
                    )}
                  />

                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Pay Period(From)"
                        format="MM/dd/yyyy"
                        name="startDate"
                        // maxDate={endDate}
                        value={startDate}
                        onChange={(e) => this.handleDateChange(e, 'startDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                        shouldDisableDate={this.disableDatesForPayCycleStart}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Pay Period(To)"
                        format="MM/dd/yyyy"
                        name="endDate"
                        minDate={startDate}
                        // maxDate={moment().endOf('month').format('MM/DD/YYYY')}
                        value={endDate}
                        maxDate={futureEndDate}
                        onChange={(e) => this.handleDateChange(e, 'endDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                        shouldDisableDate={this.disableDatesForPayCycleEnd}
                        maxDateMessage='Please select date within two Pay Periods'
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </Grid>

                <AdvancedFilter
                  filterConfig={advanceFilterConfig}
                  onApplyFilter={this.onAddvanceFilterChange}
                  openSlidingPanel={openSlidingPanel}
                  handleClose={this.handleClose}
                />
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  // handlePrintClick={this.handlePrintClick}
                  data={employeeData}
                  downloadFile={this.downloadFile}
                />
              </Grid>
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (employeeData === null || employeeData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {showReport && (employeeData.length === 0 || employeeData === null) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {this.state.showReport && (
                <div>
                  {employeeData !== null && employeeData.length > 0 && (
                    //   <div className="container" style={{ marginTop: '2px' }}>
                    //     <TableContainer component={Paper}>
                    //       {/* <Preview id={'table-pdf'} width={'1200'} height={'210'}> */}
                    //       {this.renderTable(employeeData)}
                    //       {/* </Preview> */}
                    //     </TableContainer>
                    //   </div>
                    <TableWithPaginations
                      tableData={employeeData}
                      renderTable={this.renderTable}
                      // expand={expand}
                      order={this.state.order}
                      oBy={this.state.orderBy}
                      sortData={this.getMultilevelGroupedSortedData}
                    // handleCollapse={handleCollapse}
                    />
                  )}
                </div>
              )}
            </>
          )}
      </>
    );
  }
}
